<p>
  manage-companion-account works!
</p>
